import { Checkbox, Text } from '@ui-component-library';

import type { KYCStep2Props } from './KYC.types';

export const KYCStep2 = ({ handleToggle, isSelected }: KYCStep2Props) => {

  return (
    <div className="w-full">
      <Text variant="text-lg/leading-normal/medium">
        Vad vill du att Treebula hjälper dig med just nu?
      </Text>
      <Text variant="text-sm/leading-normal/normal" className="mt-2 text-[#737373]">
        Markera vad som intresserar dig mest hos Treebula. Vi anpassar upplevelsen efter dig.
      </Text>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('jamforVirkespriser') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('jamforVirkespriser')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Jämföra virkespriser</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`jamfor-virkespriser-${isSelected('jamforVirkespriser')}`}
            name="jamfor-virkespriser"
            checked={isSelected('jamforVirkespriser')}
            onClick={() => handleToggle('jamforVirkespriser')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('digitalSkogsbruksplan') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('digitalSkogsbruksplan')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Få en digital skogsbruksplan</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`digital-skogsbruksplan-${isSelected('digitalSkogsbruksplan')}`}
            name="digital-skogsbruksplan"
            checked={isSelected('digitalSkogsbruksplan')}
            onClick={() => handleToggle('digitalSkogsbruksplan')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('kollaPaMinSkog') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('kollaPaMinSkog')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Hålla kolla på min skog</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`kolla-pa-min-skog-${isSelected('kollaPaMinSkog')}`}
            name="kolla-pa-min-skog"
            checked={isSelected('kollaPaMinSkog')}
            onClick={() => handleToggle('kollaPaMinSkog')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('seFastighetsvarde') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('seFastighetsvarde')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Se mitt fastighetsvärde</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`se-fastighetsvarde-${isSelected('seFastighetsvarde')}`}
            name="se-fastighetsvarde"
            checked={isSelected('seFastighetsvarde')}
            onClick={() => handleToggle('seFastighetsvarde')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('ekonomiKassaflode') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('ekonomiKassaflode')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Ekonomi och kassaflöde</Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`ekonomi-kassaflode-${isSelected('ekonomiKassaflode')}`}
            name="ekonomi-kassaflode"
            checked={isSelected('ekonomiKassaflode')}
            onClick={() => handleToggle('ekonomiKassaflode')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('skadeinventeringDrone') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('skadeinventeringDrone')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Skadeinventering med drönare
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`skadeinventering-drone-${isSelected('skadeinventeringDrone')}`}
            name="skadeinventering-drone"
            checked={isSelected('skadeinventeringDrone')}
            onClick={() => handleToggle('skadeinventeringDrone')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('radgivare') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('radgivare')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Prata med rådgivare
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`radgivare-${isSelected('radgivare')}`}
            name="radgivare"
            checked={isSelected('radgivare')}
            onClick={() => handleToggle('radgivare')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('kolkrediter') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('kolkrediter')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Kolkrediter
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`kolkrediter-${isSelected('kolkrediter')}`}
            name="kolkrediter"
            checked={isSelected('kolkrediter')}
            onClick={() => handleToggle('kolkrediter')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('saljaVirke') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('saljaVirke')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Sälja virke
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`salja-virke-${isSelected('saljaVirke')}`}
            name="salja-virke"
            checked={isSelected('saljaVirke')}
            onClick={() => handleToggle('saljaVirke')}
          />
        </div>
      </div>
      <div
        className={`mt-4 flex w-full cursor-pointer items-center gap-4 rounded-lg border-1 p-4 transition-colors ${isSelected('saljaBiobransle') ? 'border-[#0A0A0A]/50' : 'border-[#E6E6E6] hover:border-[#0A0A0A]/30'}`}
        onClick={() => handleToggle('saljaBiobransle')}
      >
        <div className="flex-1">
          <Text variant="text-sm/leading-normal/normal">Sälja biobränsle
          </Text>
        </div>
        <div className="shrink-0" onClick={(e) => e.stopPropagation()}>
          <Checkbox
            key={`salja-biobransle-${isSelected('saljaBiobransle')}`}
            name="salja-biobransle"
            checked={isSelected('saljaBiobransle')}
            onClick={() => handleToggle('saljaBiobransle')}
          />
        </div>
      </div>
    </div>
  );
};
